import React, { useEffect } from 'react';

// Adds a scroll-reveal effect to any element with the .reveal class
const useReveal = () => {
  useEffect(() => {
    const els = document.querySelectorAll('.reveal:not(.is-visible)');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  });
};

export default useReveal;
